import { Injectable } from '@angular/core';
import { DocumentTypeNameId } from 'src/app/compliance/models/document-type';

@Injectable({ providedIn: 'root' })
export class DocumentUploadToolVaccineService {
    private readonly _covid19: string = 'covid19';
    private readonly _covid19Exemption: string = 'covid19Exemption';
    private _vaccinesRequirements: Map<string, DocumentTypeNameId[]>;

    constructor() {
        this._buildVaccinesRequirementsSet();
    }
    A;
    isVaccineSelected(vaccine: string, docId: number): boolean {
        return this._vaccinesRequirements.get(vaccine).filter((doc) => doc.id === docId).length > 0;
    }

    private _buildVaccinesRequirementsSet(): void {
        this._vaccinesRequirements = new Map<string, DocumentTypeNameId[]>();

        this._vaccinesRequirements.set(this._covid19Exemption, [
            { id: 31890, name: 'COVID19 Declination' },
            { id: 32825, name: 'COVID19 Exemption (Medical)' },
            { id: 33414, name: 'COVID19 Declination' },
            { id: 33416, name: 'COVID19 Exemption (Medical)' },
            { id: 34240, name: 'COVID19 Exemption (Religious)' },
            { id: 35145, name: 'COVID19 Vaccine Exemption Attestation (completed by agency)' },
            { id: 37762, name: 'COVID19 Exemption (Religious)' },
            { id: 37763, name: 'COVID19 Vaccine Exemption Attestation (completed by agency)' }
        ]);

        this._vaccinesRequirements.set(this._covid19, [
            { id: 28791, name: 'COVID19 Vaccine (Dose 1)' },
            { id: 29073, name: 'COVID19 Vaccine (Dose 1)' },
            { id: 29544, name: 'COVID19 Vaccine - Fully Vaccinated (Dose 2 if applicable)' },
            { id: 33412, name: 'COVID19 Vaccine - Fully Vaccinated (Dose 2 if applicable)' },
            { id: 33695, name: 'COVID19 Vaccine - Booster' },
            { id: 37764, name: 'COVID19 Vaccine - Booster' },
            { id: 47236, name: 'COVID19 Vaccine - Booster 2' },
            { id: 47237, name: 'COVID19 Vaccine - Booster 2' }
        ]);
    }
}
